/**
 * Created by Hai Anh on 7/22/19
 */

import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'

// export default (props => <Checkbox color="default" {...props} />)

//Checkbox will be at the start of the view
const OrangeCheckbox = withStyles({
	root: {
		color: '#fc4f00',
		marginLeft: '-12px',
		'&$checked': {
			color: '#fc4f00'
		}
	},
	checked: {}
})(props => <Checkbox color="default" {...props} />)

//Checkbox will be in the middle of the view
const OrangeCenterCheckbox = withStyles({
	root: {
		color: '#fc4f00',
		'&$checked': {
			color: '#fc4f00'
		}
	},
	checked: {}
})(props => <Checkbox color="default" {...props} />)

const CustomCheckbox = ({
	checked,
	onChange,
	label,
	containerClassName,
	center,
	propagation = true,
	...props
}) => {
	const containerClass = containerClassName
		? [containerClassName].concat(['checkbox'])
		: ['checkbox']
	const stopPropagation = e => {
		if (propagation) {
			e.stopPropagation()
		}
	}
	return (
		<label className={containerClass.join(' ')} onClick={stopPropagation}>
			{center ? (
				<OrangeCenterCheckbox
					checked={checked}
					onChange={onChange}
					value={checked}
					{...props}
				/>
			) : (
				<OrangeCheckbox
					checked={checked}
					onChange={onChange}
					value={checked}
					{...props}
				/>
			)}
			<span className={'checkbox-label'}>{label != null && label}</span>
		</label>
	)
}

export default CustomCheckbox
